<template>
  <div class="page">
    <div class="main flex-col">
      <div class="flex-col">
        <img
          v-if="SIGN_STATUS === 4"
          style="width: 1rem; height: 0.94rem"
          :src="SUCCESS_URL"
          alt=""
        />
        <img
          v-else
          style="width: 1rem; height: 0.94rem"
          :src="ERROR_URL"
          alt=""
        />
        <div class="mt-12px title">
          {{ TITLE }}
        </div>
        <div class="mt-12px title" v-if="SIGN_STATUS === 5">
          驳回原因 : {{ MSG }}
        </div>
      </div>
      <div
        class="flex-col justify-between"
        style="width: 2rem; height: 1.16rem"
      >
        <div class="button bg-gradient" @click="navigateTo(1)">
          {{ SIGN_STATUS === 4 ? '继续提现' : '重新提交' }}
        </div>
        <div class="button button-plain" @click="navigateTo(2)">返回首页</div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="text">微赞推客</div>
      <div class="text2">微赞提供技术支持</div>
    </div>
  </div>
</template>

<script>
import { flexiblePayAccountInfoByEncrypt } from '@/utils/http/modules/tuoke'

// 使用 const 正确声明对象
const SignStatusReverse = {
  1: '签约中',
  4: '签约成功',
  5: '签约失败',
}

export default {
  data() {
    return {
      SUCCESS_URL:
        'https://static2.sinsam.com/zhibo/static/img/miniapp/tk/review-success.png',
      ERROR_URL:
        'https://static2.sinsam.com/zhibo/static/img/miniapp/tk/review-fail.png',
      SIGN_STATUS: 0,
      TITLE: '',
      MSG: '',
    }
  },
  mounted() {
    const { encrypt } = this.$route.query
    if (encrypt) {
      flexiblePayAccountInfoByEncrypt({ encrypt }).then(res => {
        if (res.code === 0) {
          this.SIGN_STATUS = res.dataObj.signStatus
          if (this.SIGN_STATUS === -1) {
            this.TITLE = '未签约'
          } else {
            this.TITLE = SignStatusReverse[this.SIGN_STATUS] || ''
          }
          if (this.SIGN_STATUS === 5) {
            this.MSG = res.dataObj.msg
          }
        }
      })
    }
  },
  methods: {
    navigateTo(type) {
      // 确保在微信小程序环境中
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        if (type === 1) {
          if (this.SIGN_STATUS === 4) {
            wx.miniProgram.redirectTo({
              url: '/pages/withdraw/withdraw',
            })
          } else {
            wx.miniProgram.redirectTo({
              url: '/pages/withdrawContract/withdrawContract',
            })
          }
        } else if (type === 2) {
          wx.miniProgram.switchTab({
            url: '/pages/index/index',
          })
        }
      } else {
        console.warn('当前环境不支持 wx.miniProgram')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  font-family: 'PingFang SC';
  overflow: hidden;
}
.main {
  flex: 1;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 1rem 0 0.8rem;
  box-sizing: border-box;
}
.flex-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.mt-12px {
  margin-top: 0.12rem;
}
.title {
  font-size: 16px;
  line-height: 24px;
  color: #202124;
  font-weight: 500;
  font-family: 'PingFang SC';
}
.button {
  width: 100%;
  height: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  font-weight: 500;
  border-radius: 0.25rem;
  font-family: 'PingFang SC';
  cursor: pointer;
}
.button-plain {
  color: #ff3661;
  border: 1px solid #ff3661;
  box-sizing: border-box;
}
.bg-gradient {
  background: linear-gradient(90deg, #ff448f 0%, #f44 100%);
}
.footer {
  width: 100%;
  flex-shrink: 0;
  height: 0.42rem;
  padding: 0.24rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  .text {
    height: 0.22rem;
    color: #919499;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 12%;
    font-family: 'PingFang SC';
  }
  .text2 {
    color: #bfc2cc;
    height: 0.2rem;
    font-family: 'PingFang SC';
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 6px;
  }
}
</style>
